import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DilysuService } from "src/app/craidd/gwasanaethau/defnyddiwr/dilysu.service";
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
  selector: "app-allgofnodi-ailgyfeirio",
  templateUrl: "./allgofnodi-ailgyfeirio.component.html",
  styleUrls: ["./allgofnodi-ailgyfeirio.component.scss"],
  imports: [MatProgressBar],
})
export class AllgofnodiAilgyfeirioComponent implements OnInit {
  constructor(
    private dilysuService: DilysuService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.dilysuService.allgofnodiAilgyfeirio().then(() => {
      this.dilysuService.clirioDefnyddiwr();

      this.router.navigate([""]);
    });
  }
}
